<template>
  <v-sheet :light="true" min-height="400" min-width="600">
    <base-assignment
      :available="available"
      :selected="selected"
      @save="save"
    ></base-assignment>
  </v-sheet>
</template>

<script>
import eventMixin from "@/mixins/eventMixin"
import BaseAssignment from "@/components/BaseAssignment"
import { FamiliesAPI, UsersAPI } from "@/lib/api"
import { mapGetters } from "vuex"

export default {
  mixins: [eventMixin],
  components: {
    BaseAssignment
  },
  props: {
    userId: { type: Number }
  },
  data: function() {
    return {
      available: [],
      selected: []
    }
  },
  computed: {
    ...mapGetters("users", ["getUser"])
  },
  created() {
    UsersAPI.get(this.userId)
      .then(response => {
        this.selected = response.families
      })
      .then(() => {
        FamiliesAPI.list().then(response => {
          this.available = response.filter(
            el => !this.selected.map(el => el.id).includes(el.id)
          )
        })
      })
  },
  methods: {
    save({ available, selected, newAsCopy }) {
      this.overlay = false

      let familyIds = selected.map(el => el.id)
      this.$store.dispatch("users/assignFamilies", {
        userId: this.userId,
        familyIds: familyIds
      })
      this.$emit("save", { available, selected, newAsCopy })
    }
  }
}
</script>
